<template>
    <div>
        <div
            class="toast extension-browser hidden"
            role="alert"
            aria-live="assertive"
            aria-atomic="true"
            data-autohide="false"
            data-animation="false"
        >
            <div class="toast-body bg-white text-center p-10 text-left">
                <svg
                    id="extension-chrome-logo"
                    class="hidden"
                    xmlns="http://www.w3.org/2000/svg"
                    width="50"
                    height="50"
                    viewBox="0 0 50 50"
                >
                    <g fill="none" fill-rule="nonzero">
                        <path
                            fill="#4caf50"
                            d="M50 25c0 13.805-11.195 25-25 25S0 38.805 0 25 11.195 0 25 0s25 11.195 25 25z"
                        ></path>
                        <path
                            fill="#ffc107"
                            d="M25 0v25l10 5-11.054 20H25c13.816 0 25-11.184 25-25S38.816 0 25 0z"
                        ></path>
                        <path
                            fill="#f44336"
                            d="M47.3 13.75H25V30l-3.75-1.25-17.3-17.175h-.025C8.35 4.613 16.137 0 25 0c9.75 0 18.188 5.6 22.3 13.75z"
                        ></path>
                        <path
                            fill="#ffffff"
                            d="M36.25 25c0 6.211-5.039 11.25-11.25 11.25S13.75 31.211 13.75 25 18.789 13.75 25 13.75 36.25 18.789 36.25 25z"
                        ></path>
                        <path
                            fill="#2196f3"
                            d="M33.75 25A8.748 8.748 0 0 1 25 33.75 8.748 8.748 0 0 1 16.25 25 8.748 8.748 0 0 1 25 16.25 8.748 8.748 0 0 1 33.75 25z"
                        ></path>
                    </g>
                </svg>
                <svg
                    id="extension-firefox-logo"
                    class="hidden"
                    data-name="Firefox - Large"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    width="50"
                    height="50"
                    viewBox="0 0 1024 1024"
                >
                    <defs>
                        <radialGradient
                            id="radial-gradient"
                            cx="-14480.522"
                            cy="-8329.079"
                            fx="-14509.281265145226"
                            r="450.875"
                            gradientTransform="matrix(0.762, 0.034, -0.05, 1.12, 11560.893, 10069.103)"
                            gradientUnits="userSpaceOnUse"
                        >
                            <stop offset="0.045" stop-color="#ffea00" />
                            <stop offset="0.12" stop-color="#ffde00" />
                            <stop offset="0.254" stop-color="#ffbf00" />
                            <stop offset="0.429" stop-color="#ff8e00" />
                            <stop offset="0.769" stop-color="#ff272d" />
                            <stop offset="0.872" stop-color="#e0255a" />
                            <stop offset="0.953" stop-color="#cc2477" />
                            <stop offset="1" stop-color="#c42482" />
                        </radialGradient>
                        <radialGradient
                            id="radial-gradient-2"
                            cx="-7529.669"
                            cy="-7921.608"
                            r="791.229"
                            gradientTransform="translate(9921.963 9899.103) scale(1.225 1.225)"
                            gradientUnits="userSpaceOnUse"
                        >
                            <stop offset="0" stop-color="#00ccda" />
                            <stop offset="0.22" stop-color="#0083ff" />
                            <stop offset="0.261" stop-color="#007af9" />
                            <stop offset="0.33" stop-color="#0060e8" />
                            <stop offset="0.333" stop-color="#005fe7" />
                            <stop offset="0.438" stop-color="#2639ad" />
                            <stop offset="0.522" stop-color="#401e84" />
                            <stop offset="0.566" stop-color="#4a1475" />
                        </radialGradient>
                        <linearGradient
                            id="linear-gradient"
                            x1="575.669"
                            y1="731.188"
                            x2="384.231"
                            y2="104.96"
                            gradientUnits="userSpaceOnUse"
                        >
                            <stop offset="0" stop-color="#000f43" stop-opacity="0.4" />
                            <stop offset="0.485" stop-color="#001962" stop-opacity="0.173" />
                            <stop offset="1" stop-color="#002079" stop-opacity="0" />
                        </linearGradient>
                        <radialGradient
                            id="radial-gradient-3"
                            cx="-8260.94"
                            cy="-6516.556"
                            r="266.886"
                            gradientTransform="matrix(1.219, 0.123, -0.123, 1.219, 10296.265, 9597.23)"
                            gradientUnits="userSpaceOnUse"
                        >
                            <stop offset="0.003" stop-color="#ffea00" />
                            <stop offset="0.497" stop-color="#ff272d" />
                            <stop offset="1" stop-color="#c42482" />
                        </radialGradient>
                        <radialGradient
                            id="radial-gradient-4"
                            cx="-8285.087"
                            cy="-6772.468"
                            r="445.678"
                            gradientTransform="matrix(1.219, 0.123, -0.123, 1.219, 10296.265, 9597.23)"
                            gradientUnits="userSpaceOnUse"
                        >
                            <stop offset="0.003" stop-color="#ffe900" />
                            <stop offset="0.157" stop-color="#ffaf0e" />
                            <stop offset="0.316" stop-color="#ff7a1b" />
                            <stop offset="0.472" stop-color="#ff4e26" />
                            <stop offset="0.621" stop-color="#ff2c2e" />
                            <stop offset="0.762" stop-color="#ff1434" />
                            <stop offset="0.892" stop-color="#ff0538" />
                            <stop offset="1" stop-color="#ff0039" />
                        </radialGradient>
                        <radialGradient
                            id="radial-gradient-5"
                            cx="-8222.051"
                            cy="-6359.332"
                            r="408.958"
                            gradientTransform="matrix(1.219, 0.123, -0.123, 1.219, 10296.265, 9597.23)"
                            gradientUnits="userSpaceOnUse"
                        >
                            <stop offset="0.003" stop-color="#ff272d" />
                            <stop offset="0.497" stop-color="#c42482" />
                            <stop offset="0.986" stop-color="#620700" />
                        </radialGradient>
                        <radialGradient
                            id="radial-gradient-6"
                            cx="750.189"
                            cy="396.041"
                            fx="778.1665281038617"
                            fy="382.2124050106231"
                            r="782.18"
                            gradientUnits="userSpaceOnUse"
                        >
                            <stop offset="0.156" stop-color="#ffea00" />
                            <stop offset="0.231" stop-color="#ffde00" />
                            <stop offset="0.365" stop-color="#ffbf00" />
                            <stop offset="0.541" stop-color="#ff8e00" />
                            <stop offset="0.763" stop-color="#ff272d" />
                            <stop offset="0.796" stop-color="#f92433" />
                            <stop offset="0.841" stop-color="#e91c45" />
                            <stop offset="0.893" stop-color="#cf0e62" />
                            <stop offset="0.935" stop-color="#b5007f" />
                        </radialGradient>
                        <radialGradient
                            id="radial-gradient-7"
                            cx="691.339"
                            cy="3.289"
                            r="923.615"
                            gradientUnits="userSpaceOnUse"
                        >
                            <stop offset="0.279" stop-color="#ffea00" />
                            <stop offset="0.402" stop-color="#fd0" />
                            <stop offset="0.63" stop-color="#ffba00" />
                            <stop offset="0.856" stop-color="#ff9100" />
                            <stop offset="0.933" stop-color="#ff6711" />
                            <stop offset="0.994" stop-color="#ff4a1d" />
                        </radialGradient>
                        <linearGradient
                            id="linear-gradient-2"
                            x1="-8944.65"
                            y1="-6677.742"
                            x2="-8660.289"
                            y2="-6750.226"
                            gradientTransform="matrix(1.219, 0.123, -0.123, 1.219, 10296.265, 9597.23)"
                            gradientUnits="userSpaceOnUse"
                        >
                            <stop offset="0" stop-color="#c42482" stop-opacity="0.5" />
                            <stop offset="0.474" stop-color="#ff272d" stop-opacity="0.5" />
                            <stop offset="0.486" stop-color="#ff2c2c" stop-opacity="0.513" />
                            <stop offset="0.675" stop-color="#ff7a1a" stop-opacity="0.72" />
                            <stop offset="0.829" stop-color="#ffb20d" stop-opacity="0.871" />
                            <stop offset="0.942" stop-color="#ffd605" stop-opacity="0.964" />
                            <stop offset="1" stop-color="#ffe302" />
                        </linearGradient>
                        <linearGradient
                            id="linear-gradient-3"
                            x1="245.347"
                            y1="-1082.012"
                            x2="190.775"
                            y2="-1221.859"
                            gradientTransform="matrix(0.995, 0.1, -0.1, 0.995, -173.696, 1313.941)"
                            gradientUnits="userSpaceOnUse"
                        >
                            <stop offset="0" stop-color="#891551" stop-opacity="0.6" />
                            <stop offset="1" stop-color="#c42482" stop-opacity="0" />
                        </linearGradient>
                        <linearGradient
                            id="linear-gradient-4"
                            x1="22.04"
                            y1="718.827"
                            x2="116.148"
                            y2="825.714"
                            gradientTransform="matrix(0.995, 0.1, -0.1, 0.995, 305.439, -246.471)"
                            gradientUnits="userSpaceOnUse"
                        >
                            <stop offset="0.005" stop-color="#891551" stop-opacity="0.5" />
                            <stop offset="0.484" stop-color="#ff272d" stop-opacity="0.5" />
                            <stop offset="1" stop-color="#ff272d" stop-opacity="0" />
                        </linearGradient>
                        <linearGradient
                            id="linear-gradient-5"
                            x1="200.104"
                            y1="904.616"
                            x2="200.171"
                            y2="829.835"
                            gradientTransform="matrix(0.995, 0.1, -0.1, 0.995, 305.439, -246.471)"
                            gradientUnits="userSpaceOnUse"
                        >
                            <stop offset="0" stop-color="#c42482" />
                            <stop offset="0.083" stop-color="#c42482" stop-opacity="0.81" />
                            <stop offset="0.206" stop-color="#c42482" stop-opacity="0.565" />
                            <stop offset="0.328" stop-color="#c42482" stop-opacity="0.362" />
                            <stop offset="0.447" stop-color="#c42482" stop-opacity="0.204" />
                            <stop offset="0.562" stop-color="#c42482" stop-opacity="0.091" />
                            <stop offset="0.673" stop-color="#c42482" stop-opacity="0.023" />
                            <stop offset="0.773" stop-color="#c42482" stop-opacity="0" />
                        </linearGradient>
                        <linearGradient
                            id="linear-gradient-6"
                            x1="655.531"
                            y1="38.12"
                            x2="961.187"
                            y2="721.615"
                            gradientUnits="userSpaceOnUse"
                        >
                            <stop offset="0" stop-color="#fff14f" />
                            <stop offset="0.268" stop-color="#ffee4c" />
                            <stop offset="0.452" stop-color="#ffe643" />
                            <stop offset="0.612" stop-color="#ffd834" />
                            <stop offset="0.757" stop-color="#ffc41e" />
                            <stop offset="0.892" stop-color="#ffab02" />
                            <stop offset="0.902" stop-color="#ffa900" />
                            <stop offset="0.949" stop-color="#ffa000" />
                            <stop offset="1" stop-color="#ff9100" />
                        </linearGradient>
                        <linearGradient
                            id="linear-gradient-7"
                            x1="715.885"
                            y1="431.21"
                            x2="571.098"
                            y2="819.96"
                            gradientUnits="userSpaceOnUse"
                        >
                            <stop offset="0" stop-color="#ff8e00" />
                            <stop offset="0.04" stop-color="#ff8e00" stop-opacity="0.858" />
                            <stop offset="0.084" stop-color="#ff8e00" stop-opacity="0.729" />
                            <stop offset="0.13" stop-color="#ff8e00" stop-opacity="0.628" />
                            <stop offset="0.178" stop-color="#ff8e00" stop-opacity="0.557" />
                            <stop offset="0.227" stop-color="#ff8e00" stop-opacity="0.514" />
                            <stop offset="0.282" stop-color="#ff8e00" stop-opacity="0.5" />
                            <stop offset="0.389" stop-color="#ff8e00" stop-opacity="0.478" />
                            <stop offset="0.524" stop-color="#ff8e00" stop-opacity="0.416" />
                            <stop offset="0.676" stop-color="#ff8e00" stop-opacity="0.314" />
                            <stop offset="0.838" stop-color="#ff8e00" stop-opacity="0.172" />
                            <stop offset="1" stop-color="#ff8e00" stop-opacity="0" />
                        </linearGradient>
                    </defs>
                    <g>
                        <path
                            d="M805.285,93.558c-23.947,27.884-35.1,90.639-10.818,154.256s61.5,49.8,84.7,114.673c30.623,85.6,16.369,200.589,16.369,200.589s36.814,106.609,62.468-6.633C1014.787,343.74,805.285,145.937,805.285,93.558Z"
                            style="fill: url(#radial-gradient)"
                        />
                        <path
                            id="_Path_"
                            data-name="&lt;Path&gt;"
                            d="M513.072,976.638c245.236,0,443.9-199.739,443.9-446.028S758.308,84.583,513.31,84.583,69.65,284.322,69.65,530.61C69.175,777.137,268.073,976.638,513.072,976.638Z"
                            style="fill: url(#radial-gradient-2)"
                        />
                        <path
                            d="M845.675,805.636a246.888,246.888,0,0,1-30.123,18.183,704,704,0,0,0,38.3-62.961c9.46-10.47,18.126-20.648,25.188-31.653,3.437-5.407,7.313-12.079,11.416-19.819,24.921-44.9,52.4-117.563,53.179-192.2l0-.18c.018-1.837.029-3.675.014-5.515a257.6,257.6,0,0,0-5.712-55.748c.2,1.431.376,2.861.556,4.291-.221-1.1-.407-2.212-.644-3.314.366,2.034.66,4,.976,5.983,5.094,43.217,1.466,85.372-16.682,116.45-.286.454-.58.879-.869,1.323,9.41-47.234,12.558-99.387,2.088-151.6,0,0-4.187-25.383-35.376-102.441-17.952-44.353-49.833-80.716-78-107.207-24.69-30.546-47.114-51.045-59.475-64.06-25.821-27.189-36.643-47.569-41.087-60.867-3.853-1.932-53.135-49.807-57.05-51.631-21.511,33.352-89.162,137.675-56.981,235.146,14.584,44.172,51.467,90.017,90.067,115.736,1.695,1.936,22.969,25.042,33.086,77.157C728.992,524.551,723.5,566.564,702,628.692c-25.286,54.505-90.067,108.388-150.724,113.9C421.6,754.373,374.127,677.484,374.127,677.484c46.336,18.525,97.568,14.65,128.724-4.556,31.4-19.425,50.394-33.827,65.81-28.148,15.2,5.653,27.3-10.756,16.442-27.767a78.5,78.5,0,0,0-79.4-34.573c-31.433,5.109-60.226,30.009-101.412,5.894a85.528,85.528,0,0,1-7.729-5.062c-2.715-1.785,8.826,2.717,6.133.688-8.015-4.354-22.2-13.842-25.88-17.217-.613-.562,6.219,2.179,5.606,1.616-38.51-31.712-33.7-53.134-32.49-66.57.969-10.749,7.964-24.523,19.751-30.11,5.693,3.107,9.24,5.479,9.24,5.479s-2.428-4.961-3.741-7.576c.46-.2.9-.147,1.358-.342,4.664,2.251,14.977,8.1,20.407,11.667,7.072,4.988,9.326,9.436,9.326,9.436s1.862-1.025.485-5.375c-.5-1.784-2.647-7.453-9.652-13.174l.438.049a81.2,81.2,0,0,1,11.867,8.241c1.975-7.181,5.527-14.679,4.746-28.092-.477-9.431-.257-11.873-1.919-15.515-1.488-3.128.834-4.348,3.418-1.1a32.826,32.826,0,0,0-2.208-7.4l.022-.244c3.225-11.236,68.248-40.461,72.981-43.877a67.355,67.355,0,0,0,19.132-20.8c3.617-5.763,6.337-13.848,7-26.112.355-8.844-3.759-14.734-69.507-21.618-17.981-1.771-28.531-14.8-34.526-26.823-1.094-2.59-2.209-4.937-3.325-7.282a58,58,0,0,1-2.558-8.431c10.749-30.873,28.81-56.977,55.367-76.7,1.447-1.318-5.782.338-4.336-.98,1.687-1.538,12.706-5.977,14.787-6.977,2.542-1.2-10.882-6.9-22.732-5.512-12.069,1.36-14.632,2.8-21.073,5.531,2.673-2.661,11.173-6.149,9.18-6.126-13.011,1.995-29.179,9.558-43,18.124a10.731,10.731,0,0,1,.835-4.348c-6.441,2.732-22.26,13.788-26.865,23.142a44.329,44.329,0,0,0,.266-5.4A84.483,84.483,0,0,0,351.9,227.362l-.241.219c-37.358-15.05-70.233-16.024-98.053-9.276-6.086-6.112-9.059-1.644-22.907-32.069-.941-1.832.722,1.809,0,0-2.278-5.9,1.389,7.872,0,0-23.284,18.372-53.92,39.193-68.626,53.89-.182.586,17.156-4.9,0,0-6.008,1.716-5.6,5.281-6.513,37.5-.22,2.443-.025,5.179-.223,7.378-11.748,14.968-19.749,27.643-22.775,34.211-15.193,26.18-31.926,66.992-48.146,131.551A334.364,334.364,0,0,1,110.2,400.365c-13.488,34.267-26.527,88.078-29.134,170.945a483.614,483.614,0,0,1,12.533-50.66,473.038,473.038,0,0,0,34.74,201.061c9.329,22.821,24.76,57.455,51.029,95.4,82.533,86.839,198.945,140.9,327.852,140.9C641.792,958.012,762.635,899.133,845.675,805.636Z"
                            style="fill: url(#linear-gradient)"
                        />
                        <path
                            d="M746.1,868.708c162.87-18.86,234.969-186.7,142.381-190-83.633-2.673-219.527,198.9-142.381,190Z"
                            style="fill: url(#radial-gradient-3)"
                        />
                        <path
                            d="M900.207,644.424c112.056-65.214,82.839-206.08,82.839-206.08S939.8,488.582,910.421,568.664C881.4,647.963,832.837,683.812,900.207,644.424Z"
                            style="fill: url(#radial-gradient-4)"
                        />
                        <path
                            d="M544.474,952.062c156.227,49.851,290.5-73.22,207.733-114.32C676.956,800.676,470.324,928.49,544.474,952.062Z"
                            style="fill: url(#radial-gradient-5)"
                        />
                        <path
                            d="M911.849,704.234c3.8-5.363,8.94-22.535,13.48-30.211C952.911,629.5,953.106,594,953.106,593.187c16.659-83.219,15.148-117.2,4.9-180.043-8.251-50.6-44.322-123.092-75.57-158-32.2-35.965-9.514-24.247-40.692-50.518-27.327-30.293-53.823-60.291-68.253-72.355C669.215,45.094,671.571,26.577,673.579,23.42c-.339.371-.837.922-1.472,1.643C670.872,20.14,670,16,670,16s-57,57-69,152c-7.834,62.021,15.383,126.676,49,168a381.367,381.367,0,0,0,59,58l0-.026c25.4,36.477,39.38,81.489,39.38,129.909,0,121.244-98.341,219.531-219.652,219.531a220.455,220.455,0,0,1-49.134-5.519c-57.236-10.908-90.288-39.781-106.772-59.382-9.447-11.234-13.464-19.423-13.464-19.423,51.283,18.371,107.986,14.528,142.468-4.518,34.749-19.265,55.774-33.546,72.837-27.915,16.82,5.606,30.211-10.667,18.2-27.536-11.771-16.845-42.4-40.97-87.878-34.286-34.789,5.067-66.657,29.76-112.24,5.845a96.313,96.313,0,0,1-8.554-5.02c-3.005-1.771,9.768,2.695,6.787.682-8.87-4.318-24.573-13.728-28.643-17.074-.679-.557,6.883,2.161,6.2,1.6-42.621-31.449-37.3-52.693-35.959-66.018,1.073-10.66,8.814-24.32,21.859-29.86,6.3,3.081,10.226,5.433,10.226,5.433s-2.688-4.92-4.141-7.513c.509-.194.994-.145,1.5-.339,5.162,2.232,16.576,8.029,22.586,11.57,7.827,4.947,10.322,9.358,10.322,9.358s2.061-1.016.536-5.33c-.557-1.769-2.929-7.391-10.682-13.065l.485.049a90.851,90.851,0,0,1,13.134,8.173c2.186-7.121,6.118-14.557,5.253-27.859-.528-9.352-.284-11.775-2.124-15.386-1.647-3.1.924-4.312,3.782-1.088a30.038,30.038,0,0,0-2.444-7.343l.025-.242c3.57-11.143,75.535-40.125,80.773-43.513a70.31,70.31,0,0,0,21.175-20.63c4-5.715,7.014-13.733,7.748-25.895.246-5.48-1.441-9.817-20.5-13.965-11.439-2.49-29.136-4.913-56.433-7.474-19.9-1.756-31.577-14.676-38.212-26.6-1.211-2.569-2.445-4.9-3.68-7.222a53.108,53.108,0,0,1-2.831-8.36,158.47,158.47,0,0,1,61.279-76.063c1.6-1.308-6.4.335-4.8-.972,1.868-1.525,14.063-5.927,16.367-6.919,2.813-1.186-12.044-6.84-25.159-5.466-13.357,1.349-16.194,2.776-23.323,5.486,2.959-2.639,12.366-6.1,10.161-6.075-14.4,1.978-32.3,9.479-47.6,17.973a9.676,9.676,0,0,1,.924-4.312c-7.129,2.709-24.637,13.674-29.734,22.95a39.488,39.488,0,0,0,.294-5.354,88.678,88.678,0,0,0-14.6,13.7l-.267.218c-41.347-14.925-77.732-15.891-108.522-9.2-6.736-6.061-17.566-15.226-32.892-45.4-1.041-1.817-1.6,3.755-2.4,1.961-5.955-13.813-9.553-36.444-8.962-52.046,0,0-12.318,5.614-22.513,29.06-1.893,4.215-3.107,6.54-4.32,8.865-.558.678,1.265-7.7.974-7.244-1.772,3-6.356,7.192-8.371,12.618-1.384,4.021-3.325,6.273-4.564,11.288l-.291.46c-.1-1.478.367-6.081.027-5.137a236.1,236.1,0,0,0-12.308,29.841c-5.489,18.046-11.879,42.61-12.892,74.565-.244,2.423-.027,5.136-.247,7.317-13,14.844-21.858,27.413-25.207,33.928C75.18,329.762,56.66,370.236,38.707,434.259A319.143,319.143,0,0,1,67.245,384.27C52.316,418.253,37.885,471.618,35,553.8a438.522,438.522,0,0,1,13.872-50.24c-2.578,54.8,3.805,122.74,38.449,199.393,20.57,45.087,67.921,136.649,183.62,208.1l-.01.007s39.36,29.3,107.017,51.259c5,1.814,10.065,3.6,15.234,5.333-1.622-.655-3.191-1.344-4.715-2.052a484.883,484.883,0,0,0,138.8,20.4c175.18.149,226.846-70.2,226.846-70.2s-.182.137-.513.377q3.708-3.491,7.143-7.257c-27.639,26.1-90.715,27.832-114.3,25.949,40.223-11.813,66.691-21.806,118.175-41.519Q773.655,890,783.1,885.71c.681-.3,1.368-.625,2.052-.936,1.249-.582,2.486-1.132,3.747-1.744a349.205,349.205,0,0,0,70.262-43.987c51.7-41.3,62.949-81.557,68.829-108.1-.82,2.544-3.375,8.475-5.17,12.316-13.315,28.482-42.841,45.959-74.908,60.948A688.993,688.993,0,0,0,890.3,741.773C900.767,731.39,904.033,715.148,911.849,704.234Z"
                            style="fill: url(#radial-gradient-6)"
                        />
                        <path
                            d="M848.921,802.982c21.08-23.241,40.01-49.824,54.349-79.968,36.9-77.582,93.952-206.58,49.018-341.306C916.775,275.225,868.016,217,806.107,160.122,705.563,67.756,677.482,26.521,677.482,2c0,0-116.089,129.409-65.742,264.381S765.2,396.405,833.419,537.255C913.694,703,768.47,883.869,648.375,934.493c7.353-1.633,266.97-60.383,280.614-208.882C928.68,728.342,922.83,769.414,848.921,802.982Z"
                            style="fill: url(#radial-gradient-7)"
                        />
                        <path
                            d="M512.592,321.373c.393-8.77-4.156-14.66-76.682-21.463-29.839-2.755-41.265-30.334-44.748-41.941-10.61,27.565-14.991,56.49-12.636,91.477,1.61,22.92,17.009,47.521,24.37,61.965,0,0,1.636-2.126,2.391-2.912,13.861-14.431,71.936-36.419,77.392-39.541C488.693,365.159,511.582,348.435,512.592,321.373Z"
                            style="fill: url(#linear-gradient-2)"
                        />
                        <path
                            d="M193.314,158.471c-1.041-1.818-1.6,3.754-2.4,1.961-5.955-13.813-9.578-36.2-8.72-52.022,0,0-12.318,5.614-22.513,29.06-1.893,4.215-3.107,6.54-4.32,8.865-.558.678,1.265-7.7.974-7.244-1.771,3-6.355,7.192-8.346,12.375-1.651,4.239-3.349,6.515-4.613,11.772-.389,1.429.392-6.323.052-5.379-23.711,45.825-28.237,115.114-25.738,112.184,50.478-53.9,108.325-66.683,108.325-66.683-6.155-4.534-19.528-17.625-32.7-44.889Z"
                            style="fill: url(#linear-gradient-3)"
                        />
                        <path
                            d="M384.844,722.1c-69.724-29.769-148.992-71.755-146-167.138,4.075-125.619,117.145-100.791,117.145-100.791-4.267,1.039-15.675,9.162-19.718,17.82-4.273,10.827-12.069,35.276,11.551,60.9,37.089,40.192-76.2,95.356,98.663,199.567,4.41,2.4-40.991-1.43-61.639-10.358Z"
                            style="fill: url(#linear-gradient-4)"
                        />
                        <path
                            d="M360.074,659.5c49.442,17.207,107.04,14.189,141.523-4.858,23.085-12.851,52.7-33.434,70.922-28.353-15.777-6.236-27.726-9.15-42.1-9.862-2.448,0-5.382-.052-8.048-.32a136.228,136.228,0,0,0-15.757.863c-8.9.818-18.766,6.433-27.735,5.532-.485-.049,8.7-3.774,7.953-3.605-4.752.991-9.915,1.205-15.37,1.881-3.467.386-6.449.82-9.891.963-102.982,8.733-190.017-55.813-190.017-55.813-7.408,24.95,33.166,74.3,88.521,93.572Z"
                            style="fill: url(#linear-gradient-5)"
                        />
                        <path
                            d="M848.738,803.646C952.9,701.376,1005.6,577.061,983.321,437.627c0,0,8.9,71.5-24.848,144.628,16.213-71.393,18.1-160.114-24.975-251.988C876.005,207.636,781.45,143.109,745.351,116.189,690.656,75.4,667.983,33.87,667.574,25.3c-16.339,33.477-65.766,148.2-5.31,247,56.64,92.564,145.865,120.039,208.328,204.947C985.667,633.667,848.738,803.646,848.738,803.646Z"
                            style="fill: url(#linear-gradient-6)"
                        />
                        <path
                            d="M833.814,537.551C797.412,462.35,751.978,429.55,709,394c5,7,6.232,9.473,9,14,37.827,40.316,93.607,138.656,53.11,262.107C694.881,902.482,389.967,793.057,358,762.319c12.932,134.489,238.036,198.845,384.6,111.63C826,795,893.468,660.788,833.814,537.551Z"
                            style="fill: url(#linear-gradient-7)"
                        />
                    </g>
                </svg>
                <svg
                    id="extension-edge-logo"
                    class="hidden"
                    height="50"
                    width="50"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="-13.150631399175808 4.920000000000002 291.9547293925731 272.12347840798424"
                >
                    <linearGradient
                        id="a"
                        gradientTransform="matrix(1 0 0 -1 0 266)"
                        gradientUnits="userSpaceOnUse"
                        x1="63.33"
                        x2="241.67"
                        y1="84.03"
                        y2="84.03"
                    >
                        <stop offset="0" stop-color="#0c59a4" />
                        <stop offset="1" stop-color="#114a8b" />
                    </linearGradient>
                    <radialGradient
                        id="b"
                        cx="161.83"
                        cy="68.91"
                        gradientTransform="matrix(1 0 0 -.95 0 248.84)"
                        gradientUnits="userSpaceOnUse"
                        r="95.38"
                    >
                        <stop offset=".72" stop-opacity="0" />
                        <stop offset=".95" stop-opacity=".53" />
                        <stop offset="1" />
                    </radialGradient>
                    <linearGradient
                        id="c"
                        gradientTransform="matrix(1 0 0 -1 0 266)"
                        gradientUnits="userSpaceOnUse"
                        x1="157.35"
                        x2="45.96"
                        y1="161.39"
                        y2="40.06"
                    >
                        <stop offset="0" stop-color="#1b9de2" />
                        <stop offset=".16" stop-color="#1595df" />
                        <stop offset=".67" stop-color="#0680d7" />
                        <stop offset="1" stop-color="#0078d4" />
                    </linearGradient>
                    <radialGradient
                        id="d"
                        cx="-340.29"
                        cy="62.99"
                        gradientTransform="matrix(.15 -.99 -.8 -.12 176.64 -125.4)"
                        gradientUnits="userSpaceOnUse"
                        r="143.24"
                    >
                        <stop offset=".76" stop-opacity="0" />
                        <stop offset=".95" stop-opacity=".5" />
                        <stop offset="1" />
                    </radialGradient>
                    <radialGradient
                        id="e"
                        cx="113.37"
                        cy="570.21"
                        gradientTransform="matrix(-.04 1 2.13 .08 -1179.54 -106.69)"
                        gradientUnits="userSpaceOnUse"
                        r="202.43"
                    >
                        <stop offset="0" stop-color="#35c1f1" />
                        <stop offset=".11" stop-color="#34c1ed" />
                        <stop offset=".23" stop-color="#2fc2df" />
                        <stop offset=".31" stop-color="#2bc3d2" />
                        <stop offset=".67" stop-color="#36c752" />
                    </radialGradient>
                    <radialGradient
                        id="f"
                        cx="376.52"
                        cy="567.97"
                        gradientTransform="matrix(.28 .96 .78 -.23 -303.76 -148.5)"
                        gradientUnits="userSpaceOnUse"
                        r="97.34"
                    >
                        <stop offset="0" stop-color="#66eb6e" />
                        <stop offset="1" stop-color="#66eb6e" stop-opacity="0" />
                    </radialGradient>
                    <path
                        d="M235.68 195.46a93.73 93.73 0 0 1-10.54 4.71 101.87 101.87 0 0 1-35.9 6.46c-47.32 0-88.54-32.55-88.54-74.32A31.48 31.48 0 0 1 117.13 105c-42.8 1.8-53.8 46.4-53.8 72.53 0 73.88 68.09 81.37 82.76 81.37 7.91 0 19.84-2.3 27-4.56l1.31-.44a128.34 128.34 0 0 0 66.6-52.8 4 4 0 0 0-5.32-5.64z"
                        fill="url(#a)"
                        transform="translate(-4.63 -4.92)"
                    />
                    <path
                        d="M235.68 195.46a93.73 93.73 0 0 1-10.54 4.71 101.87 101.87 0 0 1-35.9 6.46c-47.32 0-88.54-32.55-88.54-74.32A31.48 31.48 0 0 1 117.13 105c-42.8 1.8-53.8 46.4-53.8 72.53 0 73.88 68.09 81.37 82.76 81.37 7.91 0 19.84-2.3 27-4.56l1.31-.44a128.34 128.34 0 0 0 66.6-52.8 4 4 0 0 0-5.32-5.64z"
                        fill="url(#b)"
                        opacity=".35"
                        transform="translate(-4.63 -4.92)"
                    />
                    <path
                        d="M110.34 246.34A79.2 79.2 0 0 1 87.6 225a80.72 80.72 0 0 1 29.53-120c3.12-1.47 8.45-4.13 15.54-4a32.35 32.35 0 0 1 25.69 13 31.88 31.88 0 0 1 6.36 18.66c0-.21 24.46-79.6-80-79.6-43.9 0-80 41.66-80 78.21a130.15 130.15 0 0 0 12.11 56 128 128 0 0 0 156.38 67.11 75.55 75.55 0 0 1-62.78-8z"
                        fill="url(#c)"
                        transform="translate(-4.63 -4.92)"
                    />
                    <path
                        d="M110.34 246.34A79.2 79.2 0 0 1 87.6 225a80.72 80.72 0 0 1 29.53-120c3.12-1.47 8.45-4.13 15.54-4a32.35 32.35 0 0 1 25.69 13 31.88 31.88 0 0 1 6.36 18.66c0-.21 24.46-79.6-80-79.6-43.9 0-80 41.66-80 78.21a130.15 130.15 0 0 0 12.11 56 128 128 0 0 0 156.38 67.11 75.55 75.55 0 0 1-62.78-8z"
                        fill="url(#d)"
                        opacity=".41"
                        transform="translate(-4.63 -4.92)"
                    />
                    <path
                        d="M156.94 153.78c-.81 1.05-3.3 2.5-3.3 5.66 0 2.61 1.7 5.12 4.72 7.23 14.38 10 41.49 8.68 41.56 8.68a59.56 59.56 0 0 0 30.27-8.35 61.38 61.38 0 0 0 30.43-52.88c.26-22.41-8-37.31-11.34-43.91-21.19-41.45-66.93-65.29-116.67-65.29a128 128 0 0 0-128 126.2c.48-36.54 36.8-66.05 80-66.05 3.5 0 23.46.34 42 10.07 16.34 8.58 24.9 18.94 30.85 29.21 6.18 10.67 7.28 24.15 7.28 29.52s-2.74 13.33-7.8 19.91z"
                        fill="url(#e)"
                        transform="translate(-4.63 -4.92)"
                    />
                    <path
                        d="M156.94 153.78c-.81 1.05-3.3 2.5-3.3 5.66 0 2.61 1.7 5.12 4.72 7.23 14.38 10 41.49 8.68 41.56 8.68a59.56 59.56 0 0 0 30.27-8.35 61.38 61.38 0 0 0 30.43-52.88c.26-22.41-8-37.31-11.34-43.91-21.19-41.45-66.93-65.29-116.67-65.29a128 128 0 0 0-128 126.2c.48-36.54 36.8-66.05 80-66.05 3.5 0 23.46.34 42 10.07 16.34 8.58 24.9 18.94 30.85 29.21 6.18 10.67 7.28 24.15 7.28 29.52s-2.74 13.33-7.8 19.91z"
                        fill="url(#f)"
                        transform="translate(-4.63 -4.92)"
                    />
                </svg>
                <div>
                    <p id="extension-chrome-text" class="hidden text-right">{{ textChrome }}</p>
                    <p id="extension-firefox-text" class="hidden text-right">{{ textFirefox }}</p>
                    <p id="extension-edge-text" class="hidden text-right">{{ textEdge }}</p>
                    <p class="text-right">
                        <button class="btn-extension-cancel">{{ textNoBtn }}</button>
                        <a class="btn-extension-install no-margin" href="#" target="_blank">{{ textYesBtn }}</a>
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { translate } from '../../../../helper/translate';
import { globalLogger } from '../../../../helper/global-logger';
import { getBrowser } from '../../../../../lib-sat/misc/browser-detector';
import { isMobile } from '../../../../../lib-sat/misc/browser-detector';
import { browser } from '../../../../../lib-sat/misc/browser-detector';
import { isCookieSet, getCookieValue } from '../../../../helper/cookie';
import { satGlobals } from '../../../../sat/helper/sat-globals';
import 'bootstrap/js/dist/toast';
import { isExtensionInstalled } from '../../../../../lib/browser-extension/browser-extension';

/**
 * @param {Boolean} supportedBrowser
 * @param {String} cookieDomain
 */
var setExtensionCookie = function (supportedBrowser, cookieDomain) {
    // 1 year
    var maxAge = 31557600;

    if (supportedBrowser) {
        // 1 month
        maxAge = 3888000;
    }

    if (cookieDomain) {
        document.cookie = 'qgExtension=true; max-age=' + maxAge + '; secure; path=/;domain=' + cookieDomain;
    } else {
        document.cookie = 'qgExtension=true; max-age=' + maxAge + '; secure; path=/;';
    }
};

var showChromeBox = function (url) {
    if (url === '') {
        return;
    }

    $('.extension-browser').removeClass('hidden').toast('show');
    $('#extension-chrome-logo').removeClass('hidden');
    $('#extension-chrome-text').removeClass('hidden');
    $('.btn-extension-install').attr('href', url);
};

var showFirefoxBox = function (url) {
    if (url === '') {
        return;
    }

    $('.extension-browser').removeClass('hidden').toast('show');
    $('#extension-firefox-logo').removeClass('hidden');
    $('#extension-firefox-text').removeClass('hidden');
    $('.btn-extension-install').attr('href', url);
};
var showEdgeBox = function (url) {
    if (url === '') {
        return;
    }

    $('.extension-browser').removeClass('hidden').toast('show');
    $('#extension-edge-logo').removeClass('hidden');
    $('#extension-edge-text').removeClass('hidden');
    $('.btn-extension-install').attr('href', url);
};

/**
 * @param {Object} config
 * @param {?string} config.cookieDomain
 * @param {Object} config.urls
 * @param {string} config.urls.firefox
 * @param {string} config.urls.chrome
 * @param {string} config.urls.edge
 */
var init = function () {
    if (isMobile()) {
        return;
    }

    if (getCookieValue('qg_consent') === null) {
        return;
    }

    if (window.location.href.includes('feedback-chrome-extension')) {
        return;
    }

    if (window.location.href.includes('ai-creator-studio')) {
        return;
    }

    var currentBrowser = getBrowser();

    var isSupportedBrowser = false;
    if (currentBrowser === browser.CHROME || currentBrowser === browser.CHROME_HEADLESS) {
        if (!isCookieSet('qgExtension')) {
            showChromeBox(satGlobals.getBrowserExtensionUrl().chrome);
            isSupportedBrowser = true;
        }
    }

    if (currentBrowser === browser.FIREFOX) {
        if (!isCookieSet('qgExtension')) {
            showFirefoxBox(satGlobals.getBrowserExtensionUrl().firefox);
            isSupportedBrowser = true;
        }
    }
    if (currentBrowser === browser.EDGE) {
        if (!isCookieSet('qgExtension')) {
            showEdgeBox(satGlobals.getBrowserExtensionUrl().edge);
            isSupportedBrowser = true;
        }
    }

    if (isSupportedBrowser) {
        globalLogger.log('extension ' + currentBrowser + ' shown');

        $('.btn-extension-cancel').click(function () {
            $('.extension-browser').fadeOut();
            globalLogger.log('extension ' + currentBrowser + ' cancel');
        });

        $('.btn-extension-install').click(function () {
            $('.extension-browser').fadeOut();
            globalLogger.log('extension ' + currentBrowser + ' install');
        });
    }

    let cookieDomain = satGlobals.getCookieDomain();

    setExtensionCookie(isSupportedBrowser, cookieDomain);
};

export default {
    name: 'Browserextension',
    mounted() {
        this.textChrome = this.textChrome.replace('%name%', satGlobals.getProjectName);
        this.textChrome = this.textChrome.replace('%browser%', 'Chrome');
        this.textFirefox = this.textFirefox.replace('%name%', satGlobals.getProjectName);
        this.textFirefox = this.textFirefox.replace('%browser%', 'Firefox');
        this.textEdge = this.textEdge.replace('%name%', satGlobals.getProjectName);
        this.textEdge = this.textEdge.replace('%browser%', 'Edge');
        isExtensionInstalled()
            .then(() => {
                // do nothing because the extension is already installed
                // and we do not want to annoy the user with unnecessary toasts
                globalLogger.log('extension ' + getBrowser() + ' suppressed');
            })
            .catch(() => {
                // if it is not installed: init browser extension toast
                init();
            });
    },
    methods: {},
    data() {
        return {
            textChrome: translate('Install %name% %browser% Extension?'),
            textFirefox: translate('Install %name% %browser% Add-On?'),
            textEdge: translate('Install %name% %browser% Extension?'),
            textYesBtn: translate('Yes, install'),
            textNoBtn: translate('Not now'),
        };
    },
};
</script>
